module.exports = __webpack_public_path__ + "img/ic_zjh.ef41593f.png";